import { jsPDF } from 'jspdf';
import { PDFPrinterComponent } from '../components/PDFPrinterComponent';
export class PDFPrinter {
    static print(container, fileName) {
        PDFPrinter.container = container;
        PDFPrinter.pageCount = 1;
        PDFPrinter.currentPage = 1;
        PDFPrinter.pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'cm',
            format: 'a4'
        });
        PDFPrinter.pdf.setDisplayMode('fullheight');
        PDFPrinter.addFont('Pangram');
        PDFPrinter.pdf.setFont('Pangram');
        PDFPrinter.page = PDFPrinter.container.find('.document');
        PDFPrinter.page.addClass('print');
        PDFPrinter.ratio = 21 / PDFPrinter.page.width();
        let pageStart = 0;
        let yReference = 0;
        PDFPrinter.countPages();
        PDFPrinter.addPageFooter();
        PDFPrinter.page.find('.export').each((item) => {
            if (this.isItemExcluded(item))
                return;
            const x = item.position(PDFPrinter.page).x * PDFPrinter.ratio;
            let y = (item.position(PDFPrinter.page).y - yReference) * PDFPrinter.ratio;
            if (y + item.height() * PDFPrinter.ratio > this.pageBottom || item.hasClass('page-break') || (y + item.height() * PDFPrinter.ratio > this.pageBottom - 5 && item.hasClass('export-title-break'))) {
                PDFPrinter.pdf.addPage('a4');
                pageStart = 2;
                yReference = item.position(PDFPrinter.page).y;
                y = (item.position(PDFPrinter.page).y - yReference) * PDFPrinter.ratio;
                PDFPrinter.currentPage++;
                PDFPrinter.addPageFooter();
            }
            // Debug
            if (PDFPrinter.debug) {
                PDFPrinter.pdf.setDrawColor('#ff9900');
                PDFPrinter.pdf.setLineWidth(0.01);
                PDFPrinter.pdf.rect(x, pageStart + y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
            }
            // Draw
            if (item.hasClass('export-line'))
                PDFPrinter.addLine(item, x, pageStart + y);
            if (item.hasClass('export-rect'))
                PDFPrinter.addRect(item, x, pageStart + y);
            if (item.hasClass('export-text'))
                PDFPrinter.addText(item, x, pageStart + y);
            if (item.hasClass('export-image'))
                PDFPrinter.addImage(item, x, pageStart + y);
            if (item.hasClass('export-radio'))
                PDFPrinter.addRadio(item, x, pageStart + y);
        });
        PDFPrinter.page.removeClass('print');
        // remove line breaks from file name and trim
        fileName = fileName.replace(/(\r\n|\n|\r)/gm, '');
        fileName = fileName.trim();
        PDFPrinter.pdf.save(fileName + '.pdf');
    }
    static countPages() {
        let pageStart = 0;
        let yReference = 0;
        PDFPrinter.page.find('.export').each((item) => {
            if (this.isItemExcluded(item))
                return;
            const y = (item.position(PDFPrinter.page).y - yReference) * PDFPrinter.ratio;
            if (y + item.height() * PDFPrinter.ratio > this.pageBottom || item.hasClass('page-break') || (y + item.height() * PDFPrinter.ratio > this.pageBottom - 5 && item.hasClass('export-title-break'))) {
                pageStart = 2;
                yReference = item.position(PDFPrinter.page).y;
                PDFPrinter.pageCount++;
            }
        });
    }
    static addPageFooter() {
        const footerLogos = PDFPrinter.container.find('.footer-logos');
        const pageNumber = PDFPrinter.container.find('.page-number');
        const footerCopyright = PDFPrinter.container.find('.page-copyright');
        PDFPrinter.addImage(footerLogos, footerLogos.position(PDFPrinter.page).x * PDFPrinter.ratio, footerLogos.position(PDFPrinter.page).y * PDFPrinter.ratio);
        PDFPrinter.addText(pageNumber, pageNumber.position(PDFPrinter.page).x * PDFPrinter.ratio, pageNumber.position(PDFPrinter.page).y * PDFPrinter.ratio, PDFPrinter.currentPage + ' / ' + PDFPrinter.pageCount, { align: 'center' });
        PDFPrinter.addText(footerCopyright, footerCopyright.position(PDFPrinter.page).x * PDFPrinter.ratio, footerCopyright.position(PDFPrinter.page).y * PDFPrinter.ratio, footerCopyright.text());
    }
    static addFont(fontName) {
        PDFPrinter.pdf.addFileToVFS(fontName + '.ttf', PDFPrinterComponent.fonts[fontName]);
        PDFPrinter.pdf.addFont(fontName + '.ttf', fontName, 'normal');
    }
    static addLine(item, x, y) {
        PDFPrinter.pdf.setDrawColor(item.css('border-color'));
        PDFPrinter.pdf.setLineWidth(item.hasClass('export-filler') ? 0.25 : 0.01);
        PDFPrinter.pdf.line(x, y, x + item.width() * PDFPrinter.ratio, y);
    }
    static addRect(item, x, y) {
        PDFPrinter.pdf.setFillColor(item.css('background-color'));
        PDFPrinter.pdf.rect(x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio, 'F');
    }
    static addRadio(item, x, y) {
        PDFPrinter.pdf.setLineWidth(0.0025);
        PDFPrinter.pdf.setDrawColor('#000');
        PDFPrinter.pdf.setFillColor('#fff');
        PDFPrinter.pdf.circle(x + 0.2, y + 0.2, 0.2, 'FD');
        if (item.hasClass('checked')) {
            PDFPrinter.pdf.setFillColor('#000');
            PDFPrinter.pdf.circle(x + 0.2, y + 0.2, 0.1, 'F');
        }
    }
    static addImage(item, x, y) {
        if (item.get(0).tagName == 'CANVAS') {
            PDFPrinter.pdf.addImage(item.get(0), 'png', x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
        }
        else if (item.get(0).tagName == 'IMG') {
            PDFPrinter.pdf.addImage(item.get(0), 'png', x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
        }
    }
    static addText(item, x, y, text = '', options = null) {
        if (PDFPrinter.debug) {
            PDFPrinter.pdf.setDrawColor('#00ffff');
            PDFPrinter.pdf.setLineWidth(0.01);
            PDFPrinter.pdf.rect(x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
        }
        const fontSize = parseFloat(item.css('font-size')) / 1.35;
        const fontOffset = fontSize * 0.03528;
        PDFPrinter.pdf.setFontSize(fontSize);
        PDFPrinter.pdf.setCharSpace(-0.02);
        PDFPrinter.pdf.setLineHeightFactor(1.2);
        if (item.hasClass('page-copyright')) {
            PDFPrinter.pdf.setTextColor(200, 200, 200);
        }
        else {
            PDFPrinter.pdf.setTextColor(25, 25, 25);
        }
        const finalText = text ? text : PDFPrinter.pdf.splitTextToSize(item.get(0).innerText, item.width() * PDFPrinter.ratio * 1.02 + 1.3);
        PDFPrinter.pdf.text(finalText, x, y + fontOffset, options, item.hasClass('likert-label') ? 90 : 0);
        if (item.get(0).tagName === 'LI') {
            PDFPrinter.pdf.setFillColor('#000000');
            PDFPrinter.pdf.circle(x - 0.5, y + fontOffset / 2 + 0.04, 0.075, 'F');
        }
    }
    static isItemExcluded(item) {
        return (item.hasClass('print-excluded') || item.parents('.print-excluded').length > 0 || item.hasClass('d-none') || item.parents('.d-none').length > 0);
    }
}
PDFPrinter.debug = false;
PDFPrinter.pageCount = 1;
PDFPrinter.currentPage = 1;
PDFPrinter.pageBottom = 25;
